import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { GlobalConstants } from './constants/global-constants'
import { LoginComponent } from './components/login/login.component'
import { AuthGuard } from './guards/auth.guard'
import { RouteGuard } from './guards/route.guard'
import { DashboardComponent } from './components/dashboard/dashboard.component'
import { ActivityDashboardComponent } from './components/activity/dashboard/activity-dashboard.component'
import { CreateActivityComponent } from './components/activity/create-activity/create-activity.component'
import { QueryDashboardComponent } from './components/query/query-dashboard/query-dashboard.component'
import { CreateQueryComponent } from './components/query/create-query/create-query.component'
import { KnowledgeQuickSelectComponent } from './components/knowledge/quick-select/knowledge-quick-select.component'
import { SettingsComponent } from './components/settings/settings.component'
import { ProfileComponent } from './components/profile/profile.component'
import { ViewInfoComponent } from './components/view-info/view-info/view-info.component'
import { ActivityDetailsComponent } from './components/activity/activity-details/activity-details.component'
import { QueryDetailsComponent } from './components/query/query-details/query-details.component'
import { ViewKnowledgeArticleComponent } from './components/knowledge/view-knowledge-article/view-knowledge-article.component'
import { KnowledgeSearchComponent } from './components/knowledge/knowledge-search/knowledge-search.component'
import { KnowledgeSummaryComponent } from './components/knowledge/knowledge-summary/knowledge-summary.component'
import { Form11Component } from './components/form11/form11.component'
import { TutorialInfoComponent } from './components/help-info/tutorial-info/tutorial-info.component'
import { ActivitySummaryComponent } from './components/activity/summary/activity-summary.component'
import { QuerySummaryComponent } from './components/query/query-summary/query-summary.component'
import { FeedbackResponseComponent } from './components/feedback/feedback-response.component'
import { LandingComponent } from './components/landing/landing.component'
import { loginOnlyRedirectGuard } from './guards/login-only-redirect.guard'
import { rootTenantRedirectGuard } from './guards/root-tenant-redirect.guard'

import { ModuleRouteGuard } from './guards/module-route.guard'

const routes: Routes = [
  {
    path: GlobalConstants.ROUTING.LOGIN,
    canActivate: [loginOnlyRedirectGuard],
    children: []
  },
  {
    path: GlobalConstants.ROUTING.LOGIN + '/' + GlobalConstants.ROUTING.COMPANY_DOMAIN,
    component: LoginComponent,
    canActivate: [RouteGuard]
  },
  {
    path: '',
    component: LandingComponent,
    canActivate: [rootTenantRedirectGuard]
  },
  {
    path: GlobalConstants.ROUTING.DASHBOARD,
    component: DashboardComponent,
    canActivate: [AuthGuard, ModuleRouteGuard],
    data: { requiredModule: 'DASHBOARD' }
  },
  {
    path: GlobalConstants.ROUTING.ACTIVITY,
    canActivate: [AuthGuard, ModuleRouteGuard],
    data: { requiredModule: 'ACTIVITY_TRACKER' },
    children: [
      { path: GlobalConstants.ROUTING.DASHBOARD, component: ActivityDashboardComponent },
      { path: `${GlobalConstants.ROUTING.ID}/${GlobalConstants.ROUTING.DETAILS}`, component: ActivityDetailsComponent },
      { path: GlobalConstants.ROUTING.SUMMARY, component: ActivitySummaryComponent }
    ]
  },
  {
    path: GlobalConstants.ROUTING.QUERY,
    canActivate: [AuthGuard, ModuleRouteGuard],
    data: { requiredModule: 'QUERIES' },
    children: [
      { path: GlobalConstants.ROUTING.DASHBOARD, component: QueryDashboardComponent },
      { path: GlobalConstants.ROUTING.NEW, component: CreateQueryComponent },
      { path: `${GlobalConstants.ROUTING.ID}/${GlobalConstants.ROUTING.DETAILS}`, component: QueryDetailsComponent },
      { path: GlobalConstants.ROUTING.SUMMARY, component: QuerySummaryComponent }
    ]
  },
  {
    path: GlobalConstants.ROUTING.KNOWLEDGE_HUB,
    canActivate: [AuthGuard, ModuleRouteGuard],
    data: { requiredModule: 'KNOWLEDGE_BANK' },
    children: [
      { path: GlobalConstants.ROUTING.SEARCH, component: KnowledgeSearchComponent },
      { path: GlobalConstants.ROUTING.QUICK_SELECT, component: KnowledgeQuickSelectComponent },
      { path: GlobalConstants.ROUTING.LIST, component: KnowledgeSummaryComponent },
      {
        path: `${GlobalConstants.ROUTING.ID}/${GlobalConstants.ROUTING.VIEW}`,
        component: ViewKnowledgeArticleComponent
      }
    ]
  },
  {
    path: GlobalConstants.ROUTING.SETTINGS,
    canActivate: [AuthGuard],
    component: SettingsComponent
  },
  {
    path: GlobalConstants.ROUTING.PROFILE,
    component: ProfileComponent,
    canActivate: [AuthGuard]
  },
  {
    path: GlobalConstants.ROUTING.VIEW_INFO,
    canActivate: [AuthGuard],
    component: ViewInfoComponent
  },
  {
    path: `${GlobalConstants.ROUTING.FORM11_WORKFLOW}/${GlobalConstants.ROUTING.ID}/${GlobalConstants.ROUTING.STATUS}/${GlobalConstants.ROUTING.PARAM_STATUS}`,
    canActivate: [AuthGuard],
    component: Form11Component
  },
  {
    path: GlobalConstants.ROUTING.HELP,
    canActivate: [AuthGuard],
    children: [{ path: GlobalConstants.ROUTING.TUTORIAL_INFO, component: TutorialInfoComponent }]
  },
  {
    path: `${GlobalConstants.ROUTING.FEEDBACK}/${GlobalConstants.ROUTING.ID}`,
    canActivate: [AuthGuard],
    component: FeedbackResponseComponent
  }
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
